import React from 'react';

export const OssContribution = ({contributions}) => {
    if (!contributions || contributions.length === 0) {
        return null;
    }

    return (
        <ul>
            {contributions.map((contribution, index) => (
                <li key={index}>
                    <span className="date">{contribution.date}</span><br/>
                    <span className="oss-repository">{contribution.repository}</span><br/>
                    <a 
                        href={contribution.prUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="oss-pr-link"
                    >
                        {contribution.title}
                    </a>
                </li>
            ))}
        </ul>
    );
};